import React from 'react';
import { Badge, Button, Form, Table } from 'react-bootstrap';
import { conditions, machiningFields, missingDetails } from './machiningFields';

export function AssetTable({ kind, rows, categories, saving, onEdit, onSetActive, canManage = true }) {
    const definition = machiningFields[kind];
    const names = new Map(
        (categories || []).map((category) => [String(category.category), category.description])
    );
    
    return (
        <Table responsive striped hover className="align-middle">
            <thead>
                <tr>
                    <th>{definition.numberLabel}</th>
                    <th>Name</th>
                    <th>Asset No.</th>
                    <th>Category</th>
                    <th>Location</th>
                    <th>Condition</th>
                    <th>Active</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {rows.length === 0 ? (
                    <tr>
                        <td colSpan={8} className="text-center py-4">
                            No {definition.plural} match these filters.
                        </td>
                    </tr>
                ) : (
                    rows.map((row) => (
                        <tr key={row.id}>
                            <td>
                                {row[definition.number]}
                                {missingDetails(kind, row) ? (
                                    <div>
                                        <Badge bg="warning" text="dark">
                                            Incomplete details
                                        </Badge>
                                    </div>
                                ) : null}
                            </td>
                            <td>{row.name || '—'}</td>
                            <td>{row.assetNo || '—'}</td>
                            <td>{names.get(String(row.category)) || row.description || '—'}</td>
                            <td>{row.location || '—'}</td>
                            <td>
                                {row.assetCondition == null
                                    ? 'Unanswered'
                                    : conditions[row.assetCondition]}
                            </td>
                            <td>
                                {canManage ? (
                                    <Form.Check
                                        type="switch"
                                        role="switch"
                                        className="mb-0 asset-active-toggle"
                                        checked={!!row.active}
                                        disabled={saving || row.id === 'pending'}
                                        aria-label={`Active ${row[definition.number]}`}
                                        onChange={(event) => onSetActive(row, event.target.checked)}
                                    />
                                ) : row.active ? 'Yes' : 'No'}
                            </td>
                            <td>
                                <div className="d-flex align-items-center gap-2">
                                    <Button
                                        size="sm"
                                        variant="outline-primary"
                                        disabled={
                                            saving || categories === null || row.id === 'pending'
                                        }
                                        aria-label={`${canManage ? 'Edit' : 'View'} ${row[definition.number]}`}
                                        onClick={() => onEdit(row)}
                                    >
                                        {canManage ? 'Edit' : 'View details'}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))
                )}
            </tbody>
        </Table>
    );
}
